import React from 'react';
import I18n from 'app/i18n';
import csrfToken from 'app/helpers/csrf-token';
import {localDateFromISO} from 'app/utils';
import {showPopup} from 'app/utils/modals/ModalsService';
import SteamDisconnectPopup from './SteamDisconnectPopup';

interface Props {
    steamId: string | null
    steamUsername: string | null
    steamAvatarUrl: string | null
    steamLinkedAt: string | null
}

const STEAM_BUTTON_SRC = 'https://shared.fastly.steamstatic.com/community_assets/images/steamworks_docs/russian/sits_large_noborder.png';

export default class SteamInformation extends React.Component<Props> {
    handleDisconnect = (): void => {
        showPopup('steam-disconnect', props => <SteamDisconnectPopup popupId={props.popupId}/>);
    };

    renderLinked(): React.ReactNode {
        const {steamUsername, steamAvatarUrl, steamLinkedAt} = this.props;

        return <>
            <dl className="profile__info-user">
                <dt>{I18n.t('steam.labels.steam')}</dt>
                <dd className="profile__steam-linked">
                    {steamAvatarUrl && <img
                        src={steamAvatarUrl}
                        alt={steamUsername || 'Steam'}
                        className="profile__steam-avatar"
                        width={48}
                        height={48}
                    />}
                    <span>{steamUsername || this.props.steamId}</span>
                </dd>
                {steamLinkedAt && <dd className="profile__steam-linked-at">
                    {I18n.t('steam.labels.linked_at')}: {localDateFromISO(steamLinkedAt)}
                </dd>}
            </dl>
            <div className="profile__btn">
                <button className="btn" type="button" onClick={this.handleDisconnect}>
                    {I18n.t('steam.labels.disconnect')}
                </button>
            </div>
        </>;
    }

    renderNotLinked(): React.ReactNode {
        return <>
            <dl className="profile__info-user">
                <dt>{I18n.t('steam.labels.steam')}</dt>
                <dd/>
            </dl>
            <div className="profile__btn">
                <form method="post" action="/auth/steam">
                    <input type="hidden" name="authenticity_token" value={csrfToken() || ''}/>
                    <button type="submit" className="btn btn--steam" aria-label={I18n.t('steam.labels.connect')}>
                        <img
                            src={STEAM_BUTTON_SRC}
                            alt={I18n.t('steam.labels.connect')}
                        />
                    </button>
                </form>
            </div>
        </>;
    }

    render(): React.ReactNode {
        const isLinked = Boolean(this.props.steamId);
        const wrapClassName = isLinked
            ? 'profile__info-user-wrap profile__info-user-wrap--steam-linked'
            : 'profile__info-user-wrap';

        return <div className={wrapClassName}>
            {isLinked ? this.renderLinked() : this.renderNotLinked()}
        </div>;
    }
}
